import React, { PropTypes } from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BatchAddToShelfButton from '../../../shared/BatchActions/BatchAddToShelfButton';

export default function RecentlyReturnedAddToShelf({ itemsForAction, handleBatchAddToShelf }) {
  const shelfItemsSelected = itemsForAction.get('addToShelf', Immutable.List());
  return (
    <div className="cp-holds-batch-actions">
      <BatchAddToShelfButton
        selectedItemCount={shelfItemsSelected.size}
        handleClick={(shelfName) => handleBatchAddToShelf(shelfItemsSelected, shelfName)} />
    </div>
  );
}

RecentlyReturnedAddToShelf.propTypes = {
  itemsForAction: ImmutablePropTypes.map,
  handleBatchAddToShelf: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedAddToShelf/RecentlyReturnedAddToShelf.jsx